export const EMPLOYEE_PERMISSIONS = {
  AppUsers_Read: 'firestore-app-users:read',
  ExternalUserData_Read: 'firestore-external-user-data:read',
  PharmacistCheck_Read: 'firestore-pharmacist-checks:read',
  PharmacistCheck_Update: 'firestore-pharmacist-checks:update',
  MedicationAgreement_Read: 'firestore-medication-agreement:read',
  PrescriptionLine_Read: 'firestore-prescription-line:read',
  Tasks_Read: 'firestore-tasks:read',
  EmployeeUsers_Read: 'firestore-employee-users:read',
  EmployeeRoles_Read: 'firestore-employee-roles:read',
  GdsPlanning_Read: 'firestore-gds-planning:read',
  Parcels_Read: 'firestore-parcels:read',
  Parcels_Update: 'firestore-parcels:update',
  MutationRequest_Read: 'firestore-medication-agreement-mutation-request:read',
  OrderRequests_Read: 'firestore-order-requests:read',
  PlannedDeliveries_Read: 'firestore-planned-deliveries:read',
  DeliveryItems_Read: 'firestore-delivery-items:read',
  Stock_Read: 'firestore-stock-read:read',
  UsageDetails_Read: 'firestore-usage-details:read',
  Invoices_Read: 'firestore-invoices:read',
  PlanningAdjustments_Read: 'firestore-planning-adjustments:read',
  DispenseGuidrance_Read: 'firestore-dispense-guidances:read',

  DomainEvents_PlanningAdjustments_Create: 'domain-events-planning-adjustments:create',
  DomainEvents_PlanningAdjustments_Update: 'domain-events-planning-adjustments:update',
  DomainEvents_PlanningAdjustments_Delete: 'domain-events-planning-adjustments:delete',

  DomainEvents_Prescriptions_Create: 'domain-events-prescriptions:create',
  DomainEvents_Prescriptions_Update: 'domain-events-prescriptions:update',
  DomainEvents_EmployeeUsers_Update: 'domain-events-employee-users:update',
  DomainEvents_OrderRequests_Create: 'domain-events-order-requests:create',
  DomainEvents_OrderRequests_Update: 'domain-events-order-requests:update',
  DomainEvents_MutationRequests_Create:
    'domain-events-medication-agreement-mutation-requests:create',
  DomainEvents_MutationRequests_Update:
    'domain-events-medication-agreement-mutation-requests:update',
  DomainEvents_MutationRequests_Delete:
    'domain-events-medication-agreement-mutation-requests:delete',

  GoogleCloudFiles_Read: 'google-cloud-files-data:read',
  GoogleCloudFiles_Download: 'google-cloud-files:download',
  GoogleCloudFiles_Upload: 'google-cloud-files:upload',
} as const

export type EmployeePermission
  = (typeof EMPLOYEE_PERMISSIONS)[keyof typeof EMPLOYEE_PERMISSIONS]
